// Viewports;
const medias = {
  desktop: "max-width:1600px",
  laptop: "max-width:1280px",
  laptop_small: "max-width:1025px",
  tablet: "max-width:801px",
  tablet_small: "max-width:600px",
  mobile: "max-width:480px",
  mobile_small: "max-width:320px",
};

export default medias;
